<script setup>
import { useI18n } from 'vue-i18n';
import MiniCalendar from './sidebar/MiniCalendar.vue';
import SyncStatus from './sidebar/SyncStatus.vue';
import StatusFilter from './sidebar/StatusFilter.vue';

defineProps({
  selectedDate: { type: String, required: true },
  appointmentsByDate: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['select-date', 'open-archived']);
const { t } = useI18n();
</script>

<template>
  <aside
    class="hidden w-[260px] shrink-0 flex-col gap-5 overflow-y-auto border-r border-n-strong bg-n-surface-1 p-4 md:flex"
  >
    <MiniCalendar
      :selected-date="selectedDate"
      :appointments-by-date="appointmentsByDate"
      @select="d => emit('select-date', d)"
    />
    <StatusFilter />
    <SyncStatus class="mt-auto" />
    <button
      class="mt-2 w-full rounded-md border border-n-slate-5 px-3 py-1.5 text-sm text-n-slate-11 hover:bg-n-slate-2"
      @click="emit('open-archived')"
    >
      {{ t('PAINEL.ARCHIVED.BUTTON') }}
    </button>
  </aside>
</template>
